import React, { useEffect, useState } from 'react';
import api, { BASE_URL } from './api';

const MAIN_CATEGORY_NAME = '系动词';
const CATEGORY_GROUPS = [
  { key: '核心系动词', shortLabel: '核心', fullLabel: '核心系动词' },
  { key: '持续类', shortLabel: '持续', fullLabel: '持续类' },
  { key: '变化类', shortLabel: '变化', fullLabel: '变化类' },
  { key: '感官类', shortLabel: '感官', fullLabel: '感官类' },
  { key: '表象类', shortLabel: '表象', fullLabel: '表象类' },
  { key: '结果/证明类', shortLabel: '结果证明', fullLabel: '结果/证明类' },
];

const createInitialExpandedState = () =>
  CATEGORY_GROUPS.reduce((accumulator, group) => {
    accumulator[group.key] = false;
    return accumulator;
  }, {});

const pageStyles = {
  wrapper: {
    maxWidth: '1180px',
    margin: '0 auto',
    padding: '32px 20px 56px',
    color: '#1f2937',
    textAlign: 'left',
  },
  hero: {
    background: 'linear-gradient(135deg, #eff6ff 0%, #eef2ff 100%)',
    border: '1px solid #dbeafe',
    borderRadius: '20px',
    padding: '28px',
    marginBottom: '24px',
    boxShadow: '0 12px 30px rgba(15, 23, 42, 0.08)',
  },
  title: {
    margin: '0 0 10px',
    fontSize: '32px',
    lineHeight: 1.2,
    color: '#0f172a',
  },
  description: {
    margin: '0 0 14px',
    color: '#475569',
    fontSize: '15px',
    lineHeight: 1.7,
  },
  overviewGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
    gap: '10px',
    margin: '18px 0 0',
  },
  overviewItem: {
    background: 'rgba(255, 255, 255, 0.9)',
    border: '1px solid #dbeafe',
    borderRadius: '14px',
    padding: '12px 14px',
  },
  overviewName: {
    margin: 0,
    color: '#1e3a8a',
    fontWeight: 700,
    fontSize: '14px',
  },
  overviewMeta: {
    margin: '6px 0 0',
    color: '#475569',
    fontSize: '13px',
  },
  summary: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    background: '#ffffff',
    borderRadius: '999px',
    padding: '10px 16px',
    color: '#1d4ed8',
    fontWeight: 600,
  },
  stateBox: {
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '16px',
    padding: '28px',
    boxShadow: '0 10px 24px rgba(15, 23, 42, 0.05)',
  },
  card: {
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '18px',
    padding: '22px',
    marginBottom: '18px',
    boxShadow: '0 10px 24px rgba(15, 23, 42, 0.05)',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px',
    flexWrap: 'wrap',
    marginBottom: '12px',
  },
  wordTitle: {
    margin: 0,
    fontSize: '28px',
    lineHeight: 1.2,
    color: '#0f172a',
  },
  chinese: {
    margin: '6px 0 0',
    color: '#475569',
    fontSize: '17px',
  },
  badgeWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginTop: '10px',
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '6px 10px',
    borderRadius: '999px',
    background: '#eff6ff',
    color: '#1d4ed8',
    fontSize: '13px',
    fontWeight: 600,
  },
  sectionTitle: {
    margin: '18px 0 10px',
    fontSize: '15px',
    color: '#334155',
  },
  groupList: {
    display: 'grid',
    gap: '16px',
  },
  groupCard: {
    background: '#ffffff',
    border: '1px solid #dbe4f0',
    borderRadius: '18px',
    boxShadow: '0 10px 24px rgba(15, 23, 42, 0.05)',
    overflow: 'hidden',
  },
  groupHeader: {
    width: '100%',
    border: 'none',
    background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
    padding: '18px 22px',
    textAlign: 'left',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
  },
  groupTitleWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  groupTitle: {
    margin: 0,
    color: '#0f172a',
    fontSize: '20px',
    fontWeight: 700,
  },
  groupDesc: {
    margin: 0,
    color: '#64748b',
    fontSize: '14px',
  },
  groupMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: '#334155',
    whiteSpace: 'nowrap',
  },
  groupCount: {
    fontWeight: 700,
    color: '#1d4ed8',
  },
  groupArrow: {
    fontSize: '18px',
    color: '#1d4ed8',
    fontWeight: 700,
  },
  groupBody: {
    padding: '0 18px 18px',
    background: '#f8fafc',
  },
  groupEmpty: {
    padding: '18px 4px 4px',
    color: '#64748b',
    fontSize: '14px',
  },
  remark: {
    color: '#334155',
    lineHeight: 1.8,
    fontSize: '15px',
  },
  mediaBlock: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '14px',
    marginTop: '10px',
  },
  mediaItem: {
    border: '1px solid #e5e7eb',
    borderRadius: '14px',
    padding: '14px',
    background: '#f8fafc',
  },
  audio: {
    width: '100%',
    marginTop: '8px',
  },
  image: {
    maxWidth: '100%',
    borderRadius: '12px',
    display: 'block',
    marginTop: '10px',
  },
  exampleList: {
    display: 'grid',
    gap: '12px',
    marginTop: '12px',
  },
  exampleCard: {
    border: '1px solid #e5e7eb',
    borderRadius: '14px',
    padding: '14px 16px',
    background: '#f8fafc',
  },
  exampleEnglish: {
    margin: '0 0 8px',
    fontSize: '16px',
    color: '#0f172a',
  },
  exampleChinese: {
    margin: '0 0 8px',
    color: '#475569',
    lineHeight: 1.7,
  },
  muted: {
    color: '#64748b',
    fontSize: '14px',
  },
  link: {
    color: '#2563eb',
    textDecoration: 'none',
    fontWeight: 600,
  },
};

const looksLikeHtml = (content) => /<\/?[a-z][\s\S]*>/i.test(content || '');

const normalizeResponseList = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }
  return payload?.results || [];
};

const toAbsoluteUrl = (url) => {
  if (!url) {
    return '';
  }
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  return `${BASE_URL}${url.startsWith('/') ? '' : '/'}${url}`;
};

const isImageUrl = (url) => /\.(png|jpg|jpeg|gif|webp|svg)(\?.*)?$/i.test(url || '');

const renderRichText = (content) => {
  if (!content) {
    return <div style={pageStyles.muted}>暂无备注说明</div>;
  }
  if (looksLikeHtml(content)) {
    return <div style={pageStyles.remark} dangerouslySetInnerHTML={{ __html: content }} />;
  }
  return <div style={pageStyles.remark}>{content}</div>;
};

const LinkingVerbPage = () => {
  const [vocabularies, setVocabularies] = useState([]);
  const [examplesByVocabulary, setExamplesByVocabulary] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [expandedGroups, setExpandedGroups] = useState(createInitialExpandedState);

  const groupedVocabularies = CATEGORY_GROUPS.map((group) => ({
    ...group,
    items: vocabularies.filter((vocabulary) =>
      (vocabulary.categories || []).some((category) => category.name === group.key)
    ),
  }));

  const toggleGroup = (groupKey) => {
    setExpandedGroups((previous) => ({
      ...previous,
      [groupKey]: !previous[groupKey],
    }));
  };

  useEffect(() => {
    let cancelled = false;

    const loadData = async () => {
      setLoading(true);
      setError('');

      try {
        const vocabResponse = await api.fetchWithAuth(
          `/api/sentences/vocabulary/?categories__name=${encodeURIComponent(MAIN_CATEGORY_NAME)}&page_size=200`,
          { method: 'GET' }
        );

        if (!vocabResponse.ok) {
          throw new Error(`词汇接口请求失败，状态码 ${vocabResponse.status}`);
        }

        const vocabPayload = await vocabResponse.json();
        const vocabList = normalizeResponseList(vocabPayload);

        const exampleEntries = await Promise.all(
          vocabList.map(async (vocabulary) => {
            try {
              const exampleResponse = await api.fetchWithAuth(
                `/api/sentences/vocabulary-example-sentences/?vocabulary=${vocabulary.id}&page_size=100`,
                { method: 'GET' }
              );

              if (!exampleResponse.ok) {
                return [vocabulary.id, []];
              }

              const examplePayload = await exampleResponse.json();
              return [vocabulary.id, normalizeResponseList(examplePayload)];
            } catch (requestError) {
              console.error(`加载例句失败: vocabulary=${vocabulary.id}`, requestError);
              return [vocabulary.id, []];
            }
          })
        );

        if (cancelled) {
          return;
        }

        setVocabularies(vocabList);
        setExamplesByVocabulary(Object.fromEntries(exampleEntries));
      } catch (requestError) {
        if (!cancelled) {
          setError(requestError.message || '加载系动词数据失败');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadData();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div style={pageStyles.wrapper}>
      <section style={pageStyles.hero}>
        <h1 style={pageStyles.title}>📘 系动词大全</h1>
        <p style={pageStyles.description}>
          系动词是连接主语和表语的动词，它本身没有实际动作，只起连接作用，用来表示主语的状态、性质或特征。
          本页面按功能分为六大类：核心系动词、持续类、变化类、感官类、表象类、结果/证明类，点击分类卡片即可展开查看详细单词和例句。
        </p>
        <div style={pageStyles.summary}>共收录 {vocabularies.length} 个系动词词条</div>
        <div style={pageStyles.overviewGrid}>
          {groupedVocabularies.map((group) => (
            <div key={group.key} style={pageStyles.overviewItem}>
              <p style={pageStyles.overviewName}>{group.fullLabel}</p>
              <p style={pageStyles.overviewMeta}>{group.items.length} 个词条</p>
            </div>
          ))}
        </div>
      </section>

      {loading && (
        <section style={pageStyles.stateBox}>
          <div style={pageStyles.muted}>正在加载系动词词汇与例句数据...</div>
        </section>
      )}

      {!loading && error && (
        <section style={pageStyles.stateBox}>
          <div style={{ color: '#b91c1c', fontWeight: 600 }}>加载失败</div>
          <p style={{ ...pageStyles.muted, marginBottom: 0 }}>{error}</p>
        </section>
      )}

      {!loading && !error && vocabularies.length === 0 && (
        <section style={pageStyles.stateBox}>
          <div style={pageStyles.muted}>当前没有查询到“系动词”分类下的数据。</div>
        </section>
      )}

      {!loading && !error && (
        <section style={pageStyles.groupList}>
          {groupedVocabularies.map((group) => (
            <div key={group.key} style={pageStyles.groupCard}>
              <button
                type="button"
                style={pageStyles.groupHeader}
                onClick={() => toggleGroup(group.key)}
              >
                <div style={pageStyles.groupTitleWrap}>
                  <h2 style={pageStyles.groupTitle}>{group.fullLabel}</h2>
                  <p style={pageStyles.groupDesc}>点击展开查看该分类下的单词、备注、例句与音频资源</p>
                </div>
                <div style={pageStyles.groupMeta}>
                  <span style={pageStyles.groupCount}>{group.items.length} 个词条</span>
                  <span style={pageStyles.groupArrow}>{expandedGroups[group.key] ? '−' : '+'}</span>
                </div>
              </button>

              {expandedGroups[group.key] && (
                <div style={pageStyles.groupBody}>
                  {group.items.length === 0 ? (
                    <div style={pageStyles.groupEmpty}>当前分类下暂无词条。</div>
                  ) : (
                    group.items.map((vocabulary) => {
                      const examples = examplesByVocabulary[vocabulary.id] || [];
                      const subCategories = (vocabulary.categories || [])
                        .filter((category) => category.name !== MAIN_CATEGORY_NAME)
                        .map((category) => category.name);
                      const pronunciationUrl = toAbsoluteUrl(vocabulary.pronunciation_url);
                      const mediaFileUrl = toAbsoluteUrl(vocabulary.media_file_url || vocabulary.image_url);

                      return (
                        <article key={vocabulary.id} style={{ ...pageStyles.card, marginTop: '18px', marginBottom: 0 }}>
                          <div style={pageStyles.cardHeader}>
                            <div>
                              <h3 style={pageStyles.wordTitle}>{vocabulary.english}</h3>
                              <p style={pageStyles.chinese}>{vocabulary.chinese}</p>
                              <div style={pageStyles.badgeWrap}>
                                <span style={pageStyles.badge}>{MAIN_CATEGORY_NAME}</span>
                                {subCategories.map((name) => (
                                  <span key={`${vocabulary.id}-${name}`} style={pageStyles.badge}>{name}</span>
                                ))}
                              </div>
                            </div>
                            <div style={pageStyles.muted}>词汇 ID: {vocabulary.id}</div>
                          </div>

                          <div>
                            <h4 style={pageStyles.sectionTitle}>备注说明</h4>
                            {renderRichText(vocabulary.remark)}
                          </div>

                          {(pronunciationUrl || mediaFileUrl) && (
                            <div>
                              <h4 style={pageStyles.sectionTitle}>音频 / 资源</h4>
                              <div style={pageStyles.mediaBlock}>
                                {pronunciationUrl && (
                                  <div style={pageStyles.mediaItem}>
                                    <div style={{ fontWeight: 600 }}>单词发音</div>
                                    <audio controls src={pronunciationUrl} style={pageStyles.audio}>
                                      你的浏览器不支持音频播放。
                                    </audio>
                                    <a href={pronunciationUrl} target="_blank" rel="noreferrer" style={pageStyles.link}>
                                      打开发音地址
                                    </a>
                                  </div>
                                )}
                                {mediaFileUrl && (
                                  <div style={pageStyles.mediaItem}>
                                    <div style={{ fontWeight: 600 }}>相关资源</div>
                                    {isImageUrl(mediaFileUrl) ? (
                                      <img src={mediaFileUrl} alt={vocabulary.english} style={pageStyles.image} />
                                    ) : (
                                      <a href={mediaFileUrl} target="_blank" rel="noreferrer" style={pageStyles.link}>
                                        打开媒体资源
                                      </a>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          <div>
                            <h4 style={pageStyles.sectionTitle}>配套例句</h4>
                            {examples.length === 0 ? (
                              <div style={pageStyles.muted}>暂无配套例句</div>
                            ) : (
                              <div style={pageStyles.exampleList}>
                                {examples.map((example) => {
                                  const exampleAudioUrl = toAbsoluteUrl(example.pronunciation_url);
                                  return (
                                    <div key={example.id} style={pageStyles.exampleCard}>
                                      <p style={pageStyles.exampleEnglish}>{example.english}</p>
                                      <p style={pageStyles.exampleChinese}>{example.chinese}</p>
                                      {example.remark ? (
                                        <div style={pageStyles.muted}>备注：{example.remark}</div>
                                      ) : null}
                                      {exampleAudioUrl ? (
                                        <div style={{ marginTop: '10px' }}>
                                          <audio controls src={exampleAudioUrl} style={pageStyles.audio}>
                                            你的浏览器不支持音频播放。
                                          </audio>
                                          <a href={exampleAudioUrl} target="_blank" rel="noreferrer" style={pageStyles.link}>
                                            打开例句发音
                                          </a>
                                        </div>
                                      ) : null}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </article>
                      );
                    })
                  )}
                </div>
              )}
            </div>
          ))}
        </section>
      )}
    </div>
  );
};

export default LinkingVerbPage;
